export const cardTypesMap: Record<string, string> = {
  "001": "Visa",
  "002": "Mastercard",
  "003": "Amex",
  "004": "Discover",
};

export const usdOnlyCardTypes = ["Amex", "Discover"];
